<script>
export default {
    name: 'BaseRadio',

    props: {
        value: {
            type: String,
        },

        options: {
            type: Array
        }
    },

    data () {
        return {
            uid: undefined
        }
    },

    mounted() {
        const inBrowser = typeof window !== 'undefined'
        if (inBrowser) {
            this.uid = 'checkbox' + Math.random()
        }
    },
}
</script>

<template>
    <div class="base-radio">
        <div class="before">
            <slot name="before"/>
        </div>
        <label v-for="option in options" :key="option.name"
          :class="{ 'is-checked': value === option.value }">
            <input
              type="radio"
              v-on="$listeners"
              :value="option.value"
              :id="`${uid}`"
              v-bind="$attrs"
              :checked="value === option.value">
            <div class="label-text">
                <slot name="label" :option="option">
                    {{ option.name }}
                </slot>
            </div>
        </label>
        <div class="after">
            <slot name="after"/>
        </div>
    </div>
</template>


<style lang="stylus">
// @import '../assets/css/base.styl'

.base-radio
    & > label + label
        margin-top 16px

    label
        transition background-color ease .3s
        background-color $AkGreyscaleMediumUltGrey
        display flex
        align-items center
        min-height 64px
        padding-left 16px
        padding-right 16px
        flex-direction row-reverse
        justify-content space-between
        cursor pointer

        &.is-checked
            background-color var(--mainColor)
            border-color var(--mainColor)

    input
        margin 0
        padding 0

    .label-text
        font-size 14px
        color $AkGreyscaleBlack


</style>
